import React from 'react';
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer/dist/react-pdf.es';


const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        fontFamily: 'Crimson',
        marginRight:'10mm',
    },
    link: {
        fontSize: 10,
        color: 'black',
        textDecoration: 'none',
        alignSelf: 'flex-end',
        justifySelf: 'flex-end',
    },
    leftColumn:{
        borderBottomWidth: 1,
        borderBottomColor: '#db2129',
        borderBottomStyle: 'solid',
        flexDirection:'row',
        flexGrow: 11,
    },
    centerColumn: {
        flexDirection: 'column',
        flexGrow:1,
        justifyContent: 'flex-end',
        alignItems:'flex-start',
        paddingLeft: 15,
        paddingBottom: 5,
    },
    rightColumn:{
        flexDirection: 'column',
        flexGrow: 1,
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
        fontSize:9,
        paddingLeft:5,
        marginBottom:-2,
    },
    image: {
        width: 110,
        marginLeft:-10,
    },
    company:{
        fontSize: 16,
    },
    address:{
        fontSize: 12,
        marginTop:10,
    },
    subtitle: {
        fontFamily: 'Crimson',
        fontSize: 10,
        letterSpacing:4.5,
        paddingLeft:2,
        paddingTop:2,
        width:'85mm',
    }
});

export default () => (
    <View>
        <View style={styles.container}>
            <View style={styles.leftColumn}>

                <View>
                    <Image style={styles.image} src="/images/iba-logo.png" />
                </View>
                <View style={styles.centerColumn}>
                    <Text style={styles.company}>Ingenieurbau</Text>
                    <Text style={styles.company}>Altmark GmbH</Text>
                    <Text style={styles.address}>Stadtseeallee 1 - 39576 Hansestadt Stendal</Text>
                </View>
            </View>
            <View style={styles.rightColumn}>
                <Text>Telefon:</Text>
                <Text>(03931) 3 57-0</Text>
                <Text>Telefax:</Text>
                <Text>(03931) 35 73 41</Text>
                <Text>E-Mail:</Text>
                <Text>info@iba-sdl.de</Text>
                <Text>Internet:</Text>
                <Text>www.iba-sdl.de</Text>
            </View>
        </View>
        <Text style={styles.subtitle}>Ingenieurbau Altmark GmbH</Text>
    </View>
);
